/* Berzerk — Página de vendas (bloco de compra). Lê a configuração do <script data-pv-config> da seção. */
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = "1";
    var $ = function (s, el) { return (el || root).querySelector(s); };
    var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
    var C = {};
    try { C = JSON.parse($("[data-pv-config]").textContent); } catch (e) { C = {}; }
    var PRAZO = {};
    try { PRAZO = typeof C.prazos === "string" ? JSON.parse(C.prazos) : (C.prazos || {}); } catch (e) { PRAZO = {}; }
    var PRICE = +C.price || 0, FS_MIN = +C.fsMin || 0;
    var CAMP_END = C.campEnd ? new Date(C.campEnd + "T23:59:59-03:00") : null;
    var brl = function (c) { return "R$ " + (c / 100).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."); };
    var tier = +C.defaultTier || 1, variant = null, sizeTitle = "", kitTarget = 0, kitAdded = [];
    var toastEl = $("[data-toast]");
    function toast(m) {
      if (!toastEl) return; toastEl.textContent = m; clearTimeout(toastEl._t);
      requestAnimationFrame(function () {
        // sobe o aviso quando o card "Ir para o carrinho" está visível, para não cobri-lo
        var b = 90, cta = document.querySelector(".pv-kb-cta.done");
        toastEl.style.bottom = b + "px";
        if (cta && cta.offsetParent) {
          // topo final do card (sticky no rodapé do painel) e posição real do aviso: corrige a diferença
          var pr = cta.parentElement.getBoundingClientRect();
          var limite = Math.min(pr.bottom, window.innerHeight) - cta.offsetHeight - 8;
          var rt = toastEl.getBoundingClientRect();
          if (rt.bottom > limite) b += Math.round(rt.bottom - limite);
          toastEl.style.bottom = b + "px";
        }
        toastEl.classList.add("on");
        toastEl._t = setTimeout(function () { toastEl.classList.remove("on"); }, 2200);
      });
    }

    /* galeria */
    var track = $("[data-track]"), thumbs = $$("[data-thumbs] button"), badge = $("[data-model-badge]");
    if (track) {
      track.addEventListener("scroll", function () {
        var first = track.children[0]; if (!first) return;
        var w = first.offsetWidth + 6, i = Math.round(track.scrollLeft / w);
        var cur = $("[data-cur]"); if (cur) cur.textContent = i + 1;
        thumbs.forEach(function (b, j) { b.classList.toggle("on", j === i); });
        if (badge) badge.hidden = !!(track.children[i] && track.children[i].getAttribute("data-model") === "0");
      }, { passive: true });
      thumbs.forEach(function (b, i) { b.addEventListener("click", function () { if (track.children[i]) track.scrollTo({ left: track.children[i].offsetLeft, behavior: "smooth" }); }); });
    }

    /* faixas do kit */
    function tierTotal(n) { var b = $('[data-tiers] [data-n="' + n + '"]'); return b ? +b.getAttribute("data-total") : PRICE * n; }
    function paint() {
      var t = tierTotal(tier), label = tier > 1 ? (C.btnKit || "Levar [n] peças").replace("[n]", tier) : (C.btn || "Comprar agora");
      $$("[data-buy]").forEach(function (b) { b.textContent = b.closest("[data-sticky]") ? label : label + " · " + brl(t); });
      var sp = $("[data-st-price]"); if (sp) sp.textContent = brl(t);
      var ss = $("[data-st-sub]"); if (ss) ss.textContent = (tier > 1 ? "Kit de " + tier + " · " + brl(t / tier) + "/peça" : "1 peça") + (sizeTitle ? " · tam. " + sizeTitle : "");
      var note = $("[data-tier-note]");
      if (note) note.textContent = tier > 1 ? "Escolha o tamanho desta; depois você escolhe mais " + (tier - 1) + " estampa" + (tier > 2 ? "s" : "") + "." : "";
    }
    $$("[data-tiers] .pv-tier").forEach(function (b) {
      b.addEventListener("click", function () {
        tier = +b.getAttribute("data-n");
        $$("[data-tiers] .pv-tier").forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        paint();
      });
    });

    /* tamanhos */
    $$("[data-sizes] .pv-size").forEach(function (b) {
      b.addEventListener("click", function () {
        variant = b.getAttribute("data-variant"); sizeTitle = b.getAttribute("data-title");
        $$("[data-sizes] .pv-size").forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        var l = $("[data-size-label]"); if (l) l.textContent = sizeTitle;
        var w = $("[data-sizewrap]"); if (w) w.classList.remove("error");
        paint();
      });
    });

    /* carrinho do tema */
    function cartEl() { return document.querySelector("cart-notification") || document.querySelector("cart-drawer"); }
    /* aplica na gaveta o HTML que a Shopify devolve em `sections` e atualiza o contador */
    function syncCart(res) {
      var cart = cartEl();
      if (cart && res && res.sections && typeof cart.getSectionsToRender === "function") {
        cart.getSectionsToRender().forEach(function (sec) {
          var el = document.getElementById(sec.id); if (!el || !res.sections[sec.id]) return;
          var html = new DOMParser().parseFromString(res.sections[sec.id], "text/html");
          var src = html.getElementById(sec.id); if (src) el.innerHTML = src.innerHTML;
        });
        if (typeof cart.cartAction === "function") cart.cartAction();
      }
      fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll(".cart-count").forEach(function (el) { el.textContent = el.classList.contains("cart-count-drawer") ? "(" + c.item_count + ")" : c.item_count; });
        refreshKitTotal(c);
      }).catch(function () {});
    }
    /* tira uma peça do kit: a vaga some na hora; a Shopify confirma atrás (e desfaz se falhar) */
    function removeFromKit(i) {
      var it = kitAdded[i]; if (!it || it.busy) return; it.busy = true;
      kitAdded.splice(i, 1); renderKit();
      var cards = $$('[data-card][data-pid="' + it.pid + '"]');
      var still = kitAdded.some(function (x) { return x.pid === it.pid; });
      if (!still) cards.forEach(function (card) { card.classList.remove("added", "pick"); var go = $(".go", card); if (go) go.textContent = "Escolher tamanho"; });
      toast((it.title || "Peça") + " · " + it.size + " removida do kit");
      fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (c) {
        var line = null; for (var k = 0; k < c.items.length; k++) if (c.items[k].variant_id === it.variant) { line = c.items[k]; break; }
        if (!line) return null;
        var cart = cartEl(), body = { id: line.key, quantity: line.quantity - 1, sections_url: location.pathname };
        if (cart && typeof cart.getSectionsToRender === "function") body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        return fetch((window.routes && window.routes.cart_change_url) || "/cart/change", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
      }).then(function (res) { if (res) syncCart(res); else refreshKitTotal(); }).catch(function () {
        it.busy = false; kitAdded.splice(Math.min(i, kitAdded.length), 0, it); renderKit();
        cards.forEach(function (card) { card.classList.add("added"); var go = $(".go", card); if (go) go.textContent = "Adicionar outra"; });
        toast("Não foi possível remover. Tente de novo.");
      });
    }
    function addItems(items) {
      var cart = cartEl();
      var body = { items: items, sections_url: location.pathname };
      if (cart && typeof cart.getSectionsToRender === "function") body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      var url = (window.routes && window.routes.cart_add_url) || "/cart/add";
      return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || res.status || res.errors) { toast((res && res.description) || "Não foi possível adicionar. Tente outro tamanho."); return false; }
          syncCart(res);
          return true;
        }).catch(function () { toast("Falha de conexão. Tente de novo."); return false; });
    }
    function openCart() { var cart = cartEl(); if (cart && typeof cart.open === "function") cart.open(); else location.href = (window.routes && window.routes.cart_url) || "/cart"; }

    /* modais */
    function closeModals() { $$("[data-modal]").forEach(function (m) { m.classList.remove("on"); }); document.documentElement.style.overflow = ""; }
    function openModal(name) { closeModals(); var m = $('[data-modal="' + name + '"]'); if (m) { m.classList.add("on"); document.documentElement.style.overflow = "hidden"; } }
    $$("[data-open]").forEach(function (b) { b.addEventListener("click", function () { openModal(b.getAttribute("data-open")); }); });
    $$("[data-close]").forEach(function (b) { b.addEventListener("click", closeModals); });
    $$("[data-modal]").forEach(function (m) { m.addEventListener("click", function (e) { if (e.target === m) closeModals(); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeModals(); });

    /* comprar */
    var buying = false;
    function buy() {
      if (!variant) { var w = $("[data-sizewrap]"); if (w) { w.classList.add("error"); w.scrollIntoView({ behavior: "smooth", block: "center" }); } return; }
      if (buying) return; buying = true;
      var items = [{ id: +variant, quantity: 1 }];
      if (tier > 1) {
        /* abre o montador na hora, com a peça da página já na 1ª vaga; a Shopify confirma atrás */
        kitTarget = tier; var self = $("[data-self]");
        var entry = { img: self ? self.getAttribute("data-img") : "", size: sizeTitle, variant: +variant, pid: String(C.selfId), title: self ? self.getAttribute("data-title") : "" };
        kitAdded = [entry]; renderKit(); openModal("kit"); loadAllKit(); refreshKitTotal(); watchCards();
        addItems(items).then(function (ok) {
          buying = false;
          if (ok) return;
          var i = kitAdded.indexOf(entry); if (i > -1) kitAdded.splice(i, 1); renderKit();
        });
      } else {
        addItems(items).then(function (ok) { buying = false; if (ok) openCart(); });
      }
    }
    $$("[data-buy]").forEach(function (b) { b.addEventListener("click", buy); });

    /* monte seu kit + cards */
    function renderKit() {
      var n = kitAdded.length, target = Math.max(kitTarget, n);
      var t = $("[data-kb-title]"); if (t) t.textContent = "Monte seu kit · " + Math.min(n, target) + "/" + target;
      var slots = $("[data-kb-slots]");
      if (slots) { var h = ""; for (var i = 0; i < target; i++) h += kitAdded[i] ? '<div class="f"><img src="' + kitAdded[i].img + '" alt=""><span>' + kitAdded[i].size + '</span><button type="button" class="x" data-kb-rm="' + i + '" aria-label="Remover esta peça do kit">×</button></div>' : "<div>" + (i + 1) + "</div>"; slots.innerHTML = h; $$("[data-kb-rm]", slots).forEach(function (x) { x.addEventListener("click", function () { removeFromKit(+x.getAttribute("data-kb-rm")); }); }); }
      var complete = kitTarget > 0 && n >= kitTarget, cta = $("[data-kb-cta]"), done = $("[data-kb-done]");
      if (done) { done.textContent = complete ? "Ir para o carrinho" : "Ver carrinho"; done.classList.toggle("alt", !complete); }
      if (cta) { var was = cta.classList.contains("done"); cta.classList.toggle("done", complete); if (complete && !was) { cta.classList.remove("pulse"); void cta.offsetWidth; cta.classList.add("pulse"); } }
    }
    /* cards do montador: um único listener na grade (103 cards sem 700 listeners) */
    function addFromCard(card, b) {
      if (b.disabled || card.classList.contains("busy")) return;
      var go = $(".go", card), inKit = !!card.closest("[data-modal]"), pid = card.getAttribute("data-pid"), entry = null;
      card.classList.add("busy"); card.classList.remove("pick"); card.classList.add("added"); if (go) go.textContent = "Adicionar outra";
      toast(card.getAttribute("data-title") + " · " + b.getAttribute("data-title") + " adicionada");
      if (inKit) { entry = { img: card.getAttribute("data-img"), size: b.getAttribute("data-title"), variant: +b.getAttribute("data-variant"), pid: pid, title: card.getAttribute("data-title") }; kitAdded.push(entry); renderKit(); }
      addItems([{ id: +b.getAttribute("data-variant"), quantity: 1 }]).then(function (ok) {
        card.classList.remove("busy");
        if (ok) return;
        if (entry) { var i = kitAdded.indexOf(entry); if (i > -1) kitAdded.splice(i, 1); renderKit(); }
        if (!kitAdded.some(function (x) { return x.pid === pid; })) { card.classList.remove("added"); if (go) go.textContent = "Escolher tamanho"; }
      });
    }
    function onCardClick(e) {
      var card = e.target.closest("[data-card]"); if (!card) return;
      var nav = e.target.closest("[data-kb-nav]"); if (nav) { e.preventDefault(); e.stopPropagation(); cardNav(card, +nav.getAttribute("data-kb-nav")); return; }
      var go = e.target.closest(".go"), sz = e.target.closest(".szs button");
      if (go) { card.classList.toggle("pick"); go.textContent = card.classList.contains("pick") ? "Toque no tamanho" : "Escolher tamanho"; return; }
      if (sz) addFromCard(card, sz);
    }
    var kbGrid = $(".pv-kb-grid"); if (kbGrid) kbGrid.addEventListener("click", onCardClick);
    // primeiro toque/hover na foto: pré-carrega todas as fotos daquela peça, para as setas responderem na hora
    if (kbGrid) ["pointerdown", "mouseenter", "touchstart"].forEach(function (ev) { kbGrid.addEventListener(ev, function (e) { var im = e.target.closest && e.target.closest("[data-card] .im"); if (im) preloadCard(im.closest("[data-card]")); }, { passive: true, capture: true }); });

    /* todas as estampas da coleção, na ordem escolhida (Section Rendering API → sections/bzk-kit-lista.liquid) */
    var kitData = null, kitReq = null, kitRendered = false;
    function esc(s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
    function money(c) { return typeof brl === "function" ? brl(c) : "R$ " + (c / 100).toFixed(2).replace(".", ","); }
    var kitLabels = String(C.kitEtiquetas || "").split(/\n+/).map(function (l) { var p = l.split("|"); return p.length > 1 && p[0].trim() ? { k: p[0].trim().toLowerCase(), v: p[1].trim() } : null; }).filter(Boolean);
    function labelFor(p) {
      var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); }), cols = (p.collections || []).map(function (c) { return String(c).toLowerCase(); });
      for (var i = 0; i < kitLabels.length; i++) { var k = kitLabels[i].k; if (k.indexOf("tag:") === 0 ? tags.indexOf(k.slice(4).trim()) > -1 : cols.indexOf(k) > -1) return kitLabels[i].v; }
      return "";
    }
    function navHTML(n) { return n > 1 ? '<button type="button" class="nv p" data-kb-nav="-1" aria-label="Foto anterior">&#8249;</button><button type="button" class="nv n" data-kb-nav="1" aria-label="Próxima foto">&#8250;</button><span class="dt">1/' + n + "</span>" : ""; }
    var preCache = {};
    function preload(url) { if (!url || preCache[url]) return preCache[url]; var im = new Image(); im.decoding = "async"; im.src = url; preCache[url] = (im.decode ? im.decode().catch(function () {}) : Promise.resolve()); return preCache[url]; }
    function cardImgs(card) { try { return JSON.parse(card.getAttribute("data-imgs") || "[]"); } catch (e) { return []; } }
    function preloadCard(card) { if (card.getAttribute("data-pre")) return; card.setAttribute("data-pre", "1"); cardImgs(card).forEach(function (u) { preload(u); }); }
    var cardIO = ("IntersectionObserver" in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (!en.isIntersecting) return; cardIO.unobserve(en.target); var im = cardImgs(en.target); if (im[1]) { var run = function () { preload(im[1]); }; (window.requestIdleCallback ? requestIdleCallback(run, { timeout: 1500 }) : setTimeout(run, 200)); } });
    }, { rootMargin: "150px" }) : null;
    function watchCards() { if (!cardIO) return; var cs = document.querySelectorAll(".pv-kb-grid [data-card]"); for (var i = 0; i < cs.length; i++) { if (!cs[i].getAttribute("data-io")) { cs[i].setAttribute("data-io", "1"); cardIO.observe(cs[i]); } } }
    function cardNav(card, dir) {
      var imgs = cardImgs(card); if (imgs.length < 2) return;
      var i = ((+card.getAttribute("data-idx") || 0) + dir + imgs.length) % imgs.length;
      card.setAttribute("data-idx", i);
      var im = card.querySelector(".im img"), dt = card.querySelector(".im .dt");
      if (dt) dt.textContent = (i + 1) + "/" + imgs.length;
      if (!im) return;
      im.removeAttribute("srcset"); im.removeAttribute("sizes");
      var url = imgs[i], tk = (im._tk = (im._tk || 0) + 1);
      // troca só depois de decodificar (sem quadro em branco) e já pré-carrega a próxima
      preload(url).then(function () { if (im._tk === tk) im.src = url; });
      preload(imgs[(i + dir + imgs.length) % imgs.length]);
    }
    function cardHTML(p) {
      var lb = labelFor(p);
      var szs = (p.variants || []).map(function (v) { return '<button type="button" data-variant="' + v.id + '" data-title="' + esc(v.title) + '"' + (v.available ? "" : " disabled") + ">" + esc(v.title) + "</button>"; }).join("");
      return '<div class="pv-card" data-card data-pid="' + p.id + '" data-img="' + esc(p.thumb || p.image || "") + '" data-title="' + esc(p.title) + '" data-imgs="' + esc(JSON.stringify(p.imgs || [])) + '"><div class="im"><img src="' + esc(p.image || "") + '" loading="lazy" alt="' + esc(p.title) + '">' + navHTML((p.imgs || []).length) + (lb ? '<span class="lb">' + esc(lb) + "</span>" : "") + '<span class="ok">✓ No carrinho</span></div><div class="t">' + esc(p.title) + '</div><div class="pr">' + money(p.price) + '</div><div class="szs">' + szs + '</div><button type="button" class="go">Escolher tamanho</button></div>';
    }
    function fetchKitPage(n) {
      var u = "/collections/" + C.kitColecao + "?sort_by=" + encodeURIComponent(C.kitOrdem || "best-selling") + "&section_id=bzk-kit-lista&page=" + n;
      return fetch(u, { credentials: "same-origin" }).then(function (r) { return r.text(); }).then(function (t) { var i = t.indexOf("{"), j = t.lastIndexOf("}"); return JSON.parse(t.slice(i, j + 1)); });
    }
    function fetchKit() {
      if (kitReq) return kitReq;
      kitReq = fetchKitPage(1).then(function (d) {
        var more = []; for (var n = 2; n <= (d.pages || 1) && n <= 10; n++) more.push(fetchKitPage(n));
        return Promise.all(more).then(function (ds) { var all = d.products || []; ds.forEach(function (x) { all = all.concat(x.products || []); }); kitData = all; return all; });
      }).catch(function () { kitReq = null; return null; });
      return kitReq;
    }
    function renderKitGrid(list) {
      var grid = $(".pv-kb-grid"); if (!grid || !list) return;
      var self = $("[data-self]", grid), added = {};
      $$("[data-card]", grid).forEach(function (c) { if (c.classList.contains("added")) added[c.getAttribute("data-pid")] = 1; if (c !== self) c.remove(); });
      var html = "";
      list.forEach(function (p) {
        if (String(p.id) === String(C.selfId)) {
          var lb = labelFor(p), im = self && $(".im", self);
          if (lb && im && !$(".lb", im)) { var sp = document.createElement("span"); sp.className = "lb"; sp.textContent = lb; im.appendChild(sp); }
          return;
        }
        if (!p.available) return;
        html += cardHTML(p);
      });
      grid.insertAdjacentHTML("beforeend", html);
      watchCards();
      if (Object.keys(added).length) $$("[data-card]", grid).forEach(function (card) { if (added[card.getAttribute("data-pid")] && card !== self) { card.classList.add("added"); var go = $(".go", card); if (go) go.textContent = "Adicionar outra"; } });
    }
    /* total real do carrinho (com o desconto automático da Shopify) dentro do montador */
    function refreshKitTotal(cartData) {
      var el = $("[data-kb-total]"); if (!el) return;
      (cartData ? Promise.resolve(cartData) : fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); })).then(function (c) {
        if (!c || !c.item_count) { el.hidden = true; return; }
        var falta = Math.max(0, kitTarget - kitAdded.length);
        var complete = kitTarget > 0 && kitAdded.length >= kitTarget;
        if (complete) {
          var kt = tierTotal(kitTarget), kd = PRICE * kitTarget - kt;
          el.innerHTML = '<span class="ico"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg></span><div class="t"><b>Kit completo</b><small>' + kitAdded.length + ' peças · ' + money(Math.round(kt / kitTarget)) + ' cada</small></div><div class="tot"><b>' + money(kt) + "</b>" + (kd > 0 ? "<small>−" + money(kd) + "</small>" : "") + "</div>";
        } else {
          el.innerHTML = "Carrinho: <b>" + money(c.total_price) + "</b>" + (falta > 0 ? '<small class="wait">falta' + (falta > 1 ? "m " + falta + " peças" : " 1 peça") + " pro desconto</small>" : "");
        }
        el.hidden = false;
      }).catch(function () {});
    }
    function loadAllKit() {
      if (kitRendered || !C.kitColecao) return;
      if (kitData) { renderKitGrid(kitData); kitRendered = true; return; }
      var grid = $(".pv-kb-grid"), more = document.createElement("div"); more.className = "pv-kb-more"; more.textContent = "Carregando todas as estampas…"; if (grid) grid.appendChild(more);
      fetchKit().then(function (list) { more.remove(); if (list) { renderKitGrid(list); kitRendered = true; } });
    }
    if (C.kitColecao && C.kitAtivo !== false) {
      var idle = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(function () { fetchKit(); }, { timeout: 4000 }); };
      if (document.readyState === "complete") idle(); else window.addEventListener("load", idle, { once: true });
      $$("[data-tiers] .pv-tier, [data-sizes] .pv-size").forEach(function (el) { el.addEventListener("click", function () { fetchKit(); }, { once: true }); });
    }
    var kbDone = $("[data-kb-done]"); if (kbDone) kbDone.addEventListener("click", function (e) { e.stopPropagation(); closeModals(); setTimeout(openCart, 60); });
    $$("[data-goto]").forEach(function (b) {
      b.addEventListener("click", function () {
        var t = $('[data-tiers] [data-n="' + b.getAttribute("data-goto") + '"]'); if (t) t.click();
        var bb = $("[data-buybox]"); if (bb) bb.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    /* barra fixa */
    var mainBtn = $("[data-buybox] [data-buy]"), sticky = $("[data-sticky]");
    var stTick = false; if (mainBtn && sticky) window.addEventListener("scroll", function () { if (stTick) return; stTick = true; requestAnimationFrame(function () { stTick = false; var r = mainBtn.getBoundingClientRect(); sticky.classList.toggle("on", (r.bottom < 0 || r.top > window.innerHeight) && window.scrollY > 120); }); }, { passive: true });

    /* frete por CEP */
    var inp = $("[data-cep-in]");
    if (inp) {
      var F = [["SP", 1000, 19999], ["RJ", 20000, 28999], ["ES", 29000, 29999], ["MG", 30000, 39999], ["BA", 40000, 48999], ["SE", 49000, 49999], ["PE", 50000, 56999], ["AL", 57000, 57999], ["PB", 58000, 58999], ["RN", 59000, 59999], ["CE", 60000, 63999], ["PI", 64000, 64999], ["MA", 65000, 65999], ["PA", 66000, 68899], ["AP", 68900, 68999], ["AM", 69000, 69299], ["RR", 69300, 69399], ["AM", 69400, 69899], ["AC", 69900, 69999], ["DF", 70000, 72799], ["GO", 72800, 72999], ["DF", 73000, 73699], ["GO", 73700, 76799], ["RO", 76800, 76999], ["TO", 77000, 77999], ["MT", 78000, 78899], ["MS", 79000, 79999], ["PR", 80000, 87999], ["SC", 88000, 89999], ["RS", 90000, 99999]];
      var ufDe = function (c) { var p = +c.slice(0, 5); for (var i = 0; i < F.length; i++) if (p >= F[i][1] && p <= F[i][2]) return F[i][0]; return null; };
      var DIAS = ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"], MES = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
      var pad = function (n) { return String(n).length < 2 ? "0" + n : String(n); };
      var fd = function (d) { return DIAS[d.getDay()] + ", " + pad(d.getDate()) + "/" + pad(d.getMonth() + 1); };
      var addBiz = function (d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; };
      var CK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      var setText = function (sel, v) { var el = $(sel); if (el) el.textContent = v; };
      inp.addEventListener("input", function () { var v = inp.value.replace(/\D/g, "").slice(0, 8); if (v.length > 5) v = v.slice(0, 5) + "-" + v.slice(5); inp.value = v; });
      function calc(e) {
        if (e) e.preventDefault();
        var cep = inp.value.replace(/\D/g, ""), uf = cep.length === 8 ? ufDe(cep) : null, box = $("[data-ship]");
        var res = $("[data-cep-res]"), err = $("[data-cep-err]"), load = $("[data-cep-load]"), foot = $("[data-cep-foot]");
        if (res) res.hidden = true;
        if (!uf || !PRAZO[uf]) { if (err) err.hidden = false; if (box) { box.classList.remove("shake"); void box.offsetWidth; box.classList.add("shake"); } return; }
        if (err) err.hidden = true; if (foot) foot.hidden = true; if (load) load.hidden = false;
        try { localStorage.setItem("bzk_cep", inp.value); } catch (x) {}
        try { document.dispatchEvent(new CustomEvent("bzk:cep")); } catch (x) {}
        var info = null;
        Promise.all([
          fetch("https://viacep.com.br/ws/" + cep + "/json/").then(function (r) { return r.json(); }).then(function (j) { info = j && !j.erro ? j : null; }).catch(function () {}),
          new Promise(function (r) { setTimeout(r, 250); })
        ]).then(function () {
          if (load) load.hidden = true;
          var hoje = new Date(), tot = +PRAZO[uf], d1 = new Date(hoje), d2 = new Date(hoje);
          d1.setDate(d1.getDate() + Math.max(2, Math.floor(tot) - 1)); d2.setDate(d2.getDate() + Math.max(3, Math.floor(tot)));
          var where = $("[data-cep-where]"); if (where) where.innerHTML = "Entrega para <b>" + (info && info.localidade ? info.localidade + " - " + uf : uf) + "</b>";
          setText("[data-cal-mes]", MES[d2.getMonth()]); setText("[data-cal-dia]", pad(d2.getDate())); setText("[data-cal-sem]", DIAS[d2.getDay()]);
          setText("[data-cep-date]", "Chega até " + fd(d2)); setText("[data-cep-from]", "Previsão a partir de " + fd(d1));
          setText("[data-cep-post]", "até " + fd(addBiz(hoje, 2))); setText("[data-cep-end]", fd(d2));
          var T = tierTotal(tier), fr = $("[data-cep-frete]");
          if (fr) {
            fr.className = "";
            if (CAMP_END && new Date() < CAMP_END && C.campTxt) fr.innerHTML = CK + C.campTxt;
            else if (T >= FS_MIN) fr.innerHTML = CK + "Frete grátis neste pedido";
            else { fr.className = "warn"; fr.innerHTML = "Faltam " + brl(FS_MIN - T) + " para o frete grátis"; }
          }
          if (res) { res.hidden = false; res.style.animation = "none"; void res.offsetWidth; res.style.animation = ""; }
          $$("[data-st]").forEach(function (x) { x.classList.remove("on"); }); $$("[data-bar]").forEach(function (x) { x.style.width = "0"; });
          var on = function (sel, ms) { setTimeout(function () { var el = $(sel); if (el) el.classList.add("on"); }, ms); };
          var bar = function (sel, ms) { setTimeout(function () { var el = $(sel); if (el) el.style.width = "100%"; }, ms); };
          on('[data-st="1"]', 120); bar('[data-bar="1"]', 250); on('[data-st="2"]', 550); bar('[data-bar="2"]', 700); on('[data-st="3"]', 1000);
        });
      }
      var form = $("[data-cep-form]"); if (form) form.addEventListener("submit", calc);
      try { var saved = localStorage.getItem("bzk_cep"); if (saved) { inp.value = saved; calc(); } } catch (x) {}
    }

    paint();
  }
  function boot() { document.querySelectorAll("[data-bzk-pv]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", function (e) { var r = e.target && e.target.querySelector ? e.target.querySelector("[data-bzk-pv]") : null; if (r) init(r); });
})();
